module.exports = __webpack_public_path__ + "img/ninjavan.2ce550f8.png";